export default __webpack_public_path__ + "static/CONSOLA-252a062087ec8913016e64acf4e23599.ttf";